import React from 'react';


/**
 * 
 * @param {recompra} tipo Componente que se va a utilizar
 * @returns {[]} lista de pasos
 *
 */
function getListaOpciones(tipo, listaOpciones) {

  var listaOpcionesAux = []

  switch (tipo) {
    case 'recompra':
      listaOpcionesAux = [
        { id: 0, label: 'Cotización', value: 'cotizacion' },
        { id: 1, label: 'Resumen', value: 'resumen' },
        { id: 2, label: 'Confirmación', value: 'confirmacion' },
        { id: 3, label: 'Forma de Pago ', value: 'formaPago' },
      ]
      break;

    case 'apAbierto':
      listaOpcionesAux = [
        { id: 0, label: 'Cotización', value: 'cotizacion' },
        { id: 1, label: 'Resumen', value: 'resumen' },
        { id: 2, label: 'Confirmación', value: 'confirmacion' },
        { id: 3, label: 'Forma de Pago ', value: 'formaPago' },
      ]
      break;
    case 'parametrico':
      listaOpcionesAux = listaOpciones
      break;
    default:
      listaOpcionesAux = listaOpciones
      break;
  }

  return listaOpcionesAux;

}


const Steps = (props) => {
  return (
    <div className="container-step">
      <div className="wrapper-step">
        <div className="arrow-steps clearfix-step">
          {getListaOpciones(props.tipo, props.listaOpciones).map(({ id, label, value }, i) => {
            return (
              <div key={id} className={`step ${value == props.paso ? 'current' : ''}`}> {`${id + 1}. ${label}`} </div>
            )
          })}
        </div>
      </div>
    </div>
  );
};

export default Steps;
